import React from "react";
import { useSelector } from "react-redux";
import { getAppColor } from "@icarius-app/selectors";
import CommonPage from "@icarius-common/commonPage";
import { Typography, Divider } from "@material-ui/core";
import { getLocalizedString } from "@icarius-localization/strings";
import ScreenSelector from "@icarius-common/screenSelector";
import NoDataMessage from "./noDataMessage";
import useUtils from "./useUtils";

const Utils = () => {
    const { data, isLoading } = useUtils();

    const color = useSelector(getAppColor);

    return (
        <CommonPage title={getLocalizedString("utilityDownloads")} isLoading={isLoading} isNotGridPage>
            {!Boolean(data.length) && <NoDataMessage />}
            {!isLoading &&
                data?.map((item, index) => {
                    if (!item.data.length) return null;
                    return (
                        <section key={item.group} style={{ paddingBottom: index !== data.length - 1 ? 10 : 0 }}>
                            <div className={"slider-container"}>
                                <Typography className={"title"}>{item.group}</Typography>
                                <Divider style={{ background: color }} />
                            </div>
                            <ScreenSelector data={item.data} />
                        </section>
                    );
                })}
        </CommonPage>
    );
};

export default Utils;
